<!-- zym.连续型电子出版物 - 核验进度 -->
<template>
  <div class="press-5">
    <div class="tabTtl">
      <span>连续型电子出版物核验进度</span>

      <a @click="toCancel" class="downBtn" style="margin-right: 10px; margin-left: 10px">
        <el-button type="danger" size="small">整体撤回</el-button>
      </a>

      <a :href="fileUrl" class="downBtn" download>
        <el-button size="small">下载封面和盖章页</el-button>
      </a>
    </div>
    <!-- <div class="headBar">
      <span>材料1：出版单位基本信息、人员信息</span>
    </div>
    <div class="editArea">
      <el-table border :data="tabDatCommon" style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="materialTitle" label="材料名称" align="center"> </el-table-column>
        <el-table-column label="完成进度" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.code == '402'">{{ scope.row.table2Status | transStr("tabsta") }}</span>
            <span v-if="scope.row.code == '404'">{{ scope.row.table4Status | transStr("tabsta") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" align="center">
          <template slot-scope="scope">
            {{ scope.row | translate("time") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button v-if="!modifyFlag" @click="toEdit(scope.row, 2)" size="mini">查看</el-button>
            <a v-if="!modifyFlag && scope.row.code == '404'" href="javascript:void(0);" @click="expFullFile(scope.row)">
              <el-button size="mini">导出打印表</el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="headBar">
      <span>材料2：出版物信息</span>
    </div>  -->
    <div class="tabArea">
      <el-table :data="tabDat" border style="width: 100%" v-loading="loading">
        <el-table-column label="序号" width="60" align="center" type="index">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 15 * (tabPost.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column label="核验年度" align="center">
          <template slot-scope="scope">
            {{ scope.row | strTrans("year") }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="核验出版物名称" align="center"> </el-table-column>
        <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row | strTrans("pgstate") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="goDeep(scope.row)" size="mini">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageArea" v-if="tabPost.total > 1">
        <el-pagination
          :current-page="tabPost.no"
          @current-change="pageChange"
          layout="prev, pager, next"
          :page-count="tabPost.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import { getPgress } from '@/api/pressRole/pressRole';
import { getLxdzProgress } from "@/api/pressRole/pressRole";
import { expFile } from "@/api/export";

import {
  cancelTabSubmit, // zym.整体撤回提交数据
} from "@/api/pressRole/pressSuccessive";
export default {
  data() {
    return {
      tabDat: [],
      // 连续型电子出版物单位基本信息、人员基本信息
      tabDatCommon: [],
      loading: false,
      fileUrl: "",
      tabPost: {
        no: 1,
        size: 15,
        total: 0,
      },
    };
  },
  filters: {
    transStr: function (dat, code) {
      if (code == "tabsta") {
        let arrs = ["/", "已完成"];
        return arrs[dat - 1];
      }
    },
    strTrans: function (dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      }
      if (code == "pgstate") {
        let setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销",
        };

        let regist = {
          1: "未登记",
          2: "已登记",
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    },
    translate: function (dat, code) {
      // if (code == "pgress") {
      //   let transArr = ["未提交", "已提交"];
      //   return transArr[dat - 1];
      // } else if (code == "time") {
      // if (dat.status == 2) {
      return dat.updatedatpom.substr(0, 16);
      // } else {
      //   return "";
      // }
      // }
    },
  },
  methods: {
    expFullFile: function (material) {
      console.log("material=", material);
      var expUrl = "/api/export/printRyJbxx";
      var params = {
        type: 3,
        publishMaterialId: material.pomid,
      };
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
    tabInit: function () {
      this.loading = true;
      var vm = this;
      // 获取当前的年份
      let year1 = this.$store.getters.userInfo.year1;
      //  getPgress(this.tabPost).then(response => {
      getLxdzProgress({ year1: year1 }).then((response) => {
        setTimeout(function () {
          vm.tabDat = response.examineProgressList;
          // zym.20241227，出版单位基本信息、人员信息
          vm.tabDatCommon = response.flxdzOrganizationMaterialCommonList;
          vm.tabPost.total = response.totalPages;
          vm.loading = false;
        }, 300);
      });
    },
    pageChange: function (inx) {
      this.tabPost.no = inx;
      this.tabInit();
    },
    goDeep: function (dat) {
      this.$router.push({
        path: "successive_read",
        query: {
          listId: dat.publishMaterialId,
          pressId: dat.organizationId,
          bookName: dat.name,
          firstYear: dat.firstYear,
        },
      });
    },

    // zym.20241227，单位基本信息、人员信息，
    toEdit: function (row, type) {
      // let urlMap = {
      //   401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
      //   402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
      //   403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
      //   404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

      //   405: "edit_ssTab5", // pressRole/SuccessivePart/forTabs/ssTab4
      // };
      let urlMap = {
        401: "ss_skimtab1",
        402: "ss_skimtab2",
        403: "ss_skimtab3",
        404: "ss_listtab4",

        405: "ss_skimtab5", // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.pomid,
          pgress: type,

          listId: row.id, // zym.publishMaterialId

          bookName: row.materialTitle,
          mtcode: row.materialCode, // zym.materialCode 出版物的code编号
        },
      });
    },
    toCancel: function () {
      let vm = this;
      this.$confirm("确认整体撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          cancelTabSubmit().then((response) => {
            loading.close();
            // console.log('response=',JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$router.push("successive_press");
            }
          });
        })
        .catch((error) => {});
    },
  },

  created: function () {
    this.tabInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = process.env.URL_FILE + "/drmb/003.xlsx";
  },
};
</script>

<style lang="scss">
.press-5 {
  padding: 9px 12px;

  .tabTtl {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 9px;
    color: #666666;
  }

  .tabArea {
    margin-top: 10px;
  }

  .downBtn {
    float: right;
  }

  .pageArea {
    text-align: center;
    padding: 24px 0px 45px;
  }
}
</style>



// WEBPACK FOOTER //
// examProgress.vue?1e2b4880